import api from '../NetworkService';

export const getHotSpotCategoriesConfig = ({
    customerType, customerId,
}) => ({
    url: '/api/dashboard/category',
    method: 'GET',
    params: {
        [`${customerType}_id`]: customerId,
    },
});

export const getAllHotspotsForCustomerId = (selectedIdObject, startDate, endDate) => api
    .getClient()
    .get('/api/dashboard/hotspot', {
        data: {
            ...selectedIdObject,
            start_date: startDate,
            end_date: endDate,
        },
    }).then(response => response.data);

export const getCategories = selectedIdObject => api
    .getClient()
    .get('/api/dashboard/category', {
        params: {
            ...selectedIdObject,
        },
    })
    .then(response => response.data);

export const deleteHotspot = hotspotId => api
    .getClient()
    .delete(`/api/dashboard/hotspot/${hotspotId}`);

export const createHotspot = ({
    categories,
    description,
    endDate,
    selectedIdObject,
    startDate,
    title,
    ...rest
}) => api
    .getClient()
    .post('/api/dashboard/hotspot', {
        categories,
        description,
        end_date: endDate || '',
        start_date: startDate,
        title,
        ...rest,
        ...selectedIdObject,
    })
    .then(response => response.data);

export const editHotspot = hotspot => api
    .getClient()
    .post('/api/dashboard/hotspot',
        {
            ...hotspot,
            end_date: hotspot.endDate,
            start_date: hotspot.startDate,
        })
    .then(response => response.data);
